import PropTypes from 'prop-types';
import { createContext, useCallback } from 'react';

// project imports
import config from 'config';
import useLocalStorage from 'hooks/useLocalStorage';

const initialState = {
  i18n: config.i18n,
  onChangeLocalization: () => {}
};

// ==============================|| LOCALE CONTEXT & PROVIDER ||============================== //

const LocaleContext = createContext(initialState);

function LocaleProvider({ children }) {
  const [locale, setLocale] = useLocalStorage('mantis-react-locale', { i18n: config.i18n });

  const onChangeLocalization = useCallback(
    (lang) => {
      setLocale({ i18n: lang });
    },
    [setLocale]
  );

  return (
    <LocaleContext
      value={{
        i18n: locale.i18n,
        onChangeLocalization
      }}
    >
      {children}
    </LocaleContext>
  );
}

export { LocaleProvider, LocaleContext };

LocaleProvider.propTypes = { children: PropTypes.node };
